<script>
import SelectOne from './SelectOne.vue';

const ages = ['года', 'год', 'года', 'года', 'года', 'лет', 'лет', 'лет', 'лет', 'лет', 'лет', 'лет', 'лет', 'лет', 'лет'];

export default {
  components: {
    SelectOne,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        adult: 0,
        child: [],
      }),
    },
  },
  data() {
    return {
      active: false,
      optionsChild: ages.map((i, idx) => ({
        value: idx,
        label: `${idx === 0 ? 'до 1' : idx} ${i}`,
      })),
      ages,
    };
  },
  methods: {
    handlerClickAdult(value) {
      if (this.adult + value < 0) return;
      this.value.adult += value;
      this.handlerInput();
    },
    handlerAddChild(value) {
      this.value.child = this.value.child.concat(value.value);
      this.handlerInput();
    },
    handlerRemoveChild(value) {
      this.value.child.splice(value, 1);
      this.handlerInput();
    },
    handlerInput() {
      this.$emit('input', {
        adult: this.value.adult,
        child: [
          ...this.value.child,
        ],
      });
    },
  },
  computed: {
    adult() {
      return this.value?.adult || 0;
    },
    child() {
      return this.value?.child || 0;
    },
    labelAdult() {
      if (this.adult === 1) {
        return `${this.adult} взрослый`;
      }
      return `${this.adult} взрослых`;
    },
    childAges() {
      return `${this.value.child.length} детей`;
    },
  },
  mounted() {
    this.$watch('$refs.popover1.showPopper', (value) => {
      this.active = value;
    });
  },
};
</script>
<template>
  <div
    class="f-c-tourist"
    :class="{'is-active':active}"
  >
    <el-popover
      ref="popover1"
      placement="bottom-start"
      popper-class="f-c-tourist__popper"
      trigger="click"
      append-to-body
    >
      <div>
        <div class="f-c-tourist-group">
          <div class="f-c-tourist-group__btn">
            <FItemBtn
              icon="el-icon-minus"
              @click="handlerClickAdult(-1)"
            />
          </div>
          <div class="f-c-tourist-group__input">
            {{labelAdult}}
          </div>
          <div class="f-c-tourist-group__btn">
            <FItemBtn
              icon="el-icon-plus"
              @click="handlerClickAdult(1)"
            />
          </div>
        </div>
        <div class="f-c-tourist-group">
          <SelectOne
            :value="null"
            @change="handlerAddChild"
            :options="optionsChild"
            placeholder="Добавить ребенка"
          />
        </div>
        <div
          v-for="(item, idx) in child"
          :key="idx"
          class="f-c-tourist-group"
        >
          <div class="f-c-tourist-group__btn">
            Ребенок:
          </div>
          <div class="f-c-tourist-group__input">
            {{optionsChild[item].label}}
          </div>
          <div class="f-c-tourist-group__btn">
            <FItemBtn
              icon="el-icon-error"
              @click="handlerRemoveChild(idx)"
            />
          </div>
        </div>
      </div>
    </el-popover>
    <div
      class="f-c-input"
      v-popover:popover1
    >
      <span>{{labelAdult}},</span> <span style="font-size: 14px">{{childAges}}</span>
    </div>
  </div>
</template>
<style lang="scss">
  .f-c-tourist {
    &__popper {
      margin-top: 1px !important;

      .popper__arrow {
        display: none !important;
      }
    }

    &-group {
      display: flex;
      margin: 8px 0;
      padding: 4px 0;
      height: 32px;
      font-size: 16px;

      &__btn {
        flex-shrink: 0;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      &__input {
        justify-content: center;
        align-items: center;
        flex: 1;
        display: flex;
        height: 24px;
      }
    }
  }
</style>
